import config from '~/config';
import CookieService from '~/utils/CookieService';
import ErrorService from '~/utils/ErrorService';
import classNames from 'classnames';

interface Cvss2RiskCount {
  high: number,
  medium: number,
  low: number
}

interface RiskCount extends Cvss2RiskCount {
  critical: number
}

const CvssService = {
  isCvss3Enabled: () => {
    const enabledFeatures = config.ENABLED_FEATURES;
    return enabledFeatures ? enabledFeatures.includes('cvss3') : false;
  },
  isCvss2Selected: () => {
    return CookieService.getCookie('cvss_selection') === 'cvss2';
  },
  setCvssSelection: (cvss: 'cvss2' | 'cvss3') => {
    if (!['cvss2', 'cvss3'].includes(cvss)) {
      ErrorService.capture(`Invalid value: ${cvss} set for user cvss_selection.`);
      return;
    }

    CookieService.setCookieNoExpiry('cvss_selection', cvss);
  },
  getCvss3Severity: (score: number) => {
    if (!score) return 'Unknown';
    else if (score < 4) return 'Low';
    else if (score < 7) return 'Medium';
    else if (score < 9) return 'High';
    else return 'Critical';
  },
  getCvssSeverity: (score: number) => {
    if (!score) return 'Unknown';
    else if (score < 4) return 'Low';
    else if (score < 7) return 'Medium';
    else return 'High';
  },
  getCvssSeverityByInstanceRiskCount: (riskCount: Cvss2RiskCount) => {
    const { high, medium, low } = riskCount;
    if (high > 0) return 'High';
    else if (medium > 0) return 'Medium';
    else if (low > 0) return 'Low';
    return '--';
  },
  getCvss3SeverityByInstanceRiskCount: (riskCount: RiskCount) => {
    const { critical, high, medium, low } = riskCount;
    if (critical > 0) return 'Critical';
    else if (high > 0) return 'High';
    else if (medium > 0) return 'Medium';
    else if (low > 0) return 'Low';
    return '--';
  },
  getRiskColorClassByVectorLevel: (cvssVectorLevel: 'Critical' | 'High' | 'Medium' | 'Low') => {
    return classNames({
      'bg-color--danger--dark': cvssVectorLevel === 'Critical',
      'bg-color--danger': cvssVectorLevel === 'High',
      'bg-color--warning': cvssVectorLevel === 'Medium',
      'bg-color--warning-light': cvssVectorLevel === 'Low',
    });
  }
};

export default CvssService;
